<template>
	<div :class="['card', ...variantClassList]">
		<component
			:class="[
				'card__main',
				parentTag === 'a' && 'card__main--clickable'
			]"
			:is="!parentTag ? 'div' : parentTag"
			:href="href"
		>
			<div class="card__header" v-if="$slots['card-header'] != undefined">
				<slot name="card-header" />
			</div>
			<div class="card__body" v-if="$slots['card-body'] != undefined">
				<slot name="card-body" />
			</div>
		</component>
		<div
			:class="'card__additional'"
			v-if="$slots['card-additional'] != undefined"
		>
			<slot name="card-additional" />
		</div>
	</div>
</template>

<script>
import baseComponentMixin from '@/mixins/base-component-mixin';
import componentVariantMixin from '@/mixins/component-variant-mixin';
import variantClasses from './variant-classes/card-variant-classes';

export default {
	name: 'Card',
	mixins: [componentVariantMixin, baseComponentMixin],
	props: {
		cardClass: {
			type: String,
			default: 'card__additional'
		},
		parentTag: {
			type: String,
			default: null
		},
		headerTag: {
			type: String,
			default: null
		},
		subHeaderTag: {
			type: String,
			default: null
		},
		href: {
			type: [String, Boolean],
			default: false
		},
		isClickable: {
			type: Boolean,
			default: true
		}
	},
	created() {
		this.variantClasses = variantClasses;
	}
};
</script>

<style lang="scss" scoped>
.card {
	display: inline-flex;
	flex-direction: column;
	border-radius: $border-radius;
	width: auto;
	height: auto;
	text-align: left;
	border: $card-border;
	font-size: $txt-font-size;
	background: var(--bg-0);
	color: var(--bg-0-fg-4);

	&:has(.card-button){
		background: var(--bg-1);
	}

	&__main {
		display: inline-block;
		width: 100%;
		transition: all 0.1s ease-in-out;
		border-radius: $border-radius;
		height: 100%;

		&--clickable {
			cursor: pointer;

			&:hover,
			&:focus-within {
				background: var(--bg-brand-1);
				color: var(--bg-brand-1-fg-2);

				&:deep(*:not(.tooltip)*:not(card-button)) {
					color: var(--bg-brand-1-fg-2);
				}

				&:deep(.color-indicator__icon) {
					color: var(--bg-brand-1-fg-2);
				}

				&:has(.card-button) {
					background: var(--bg-2);
					outline: 2px solid var(--brand-2);
					border-radius: calc($border-radius * .5);
					transition: none;
				}

				border-radius: $border-radius $border-radius 0 0;
			}
		}
	}

	&__header {
		padding: $padding-sm $padding-sm 0 $padding-sm;
		font-weight: $bold-font-weight;
	}

	&__body {
		padding: $padding-sm;
	}

	&__additional {
		padding: $padding-sm;
		border-top: $field-border;
	}
}

/* Variant Styles */

.card--bg-1 {
	background: var(--bg-1);
	color: var(--bg-1-fg-3);
}

.card--bg-2 {
	background: var(--bg-2);
	color: var(--bg-2-fg-3);
}
</style>
